const module = { name: 'movie/overview/newFanalert', exports: {} }; const exports = module.exports;



import { fd_location as fd_location_getLocation } from 'require-global';

const { getLocation } = fd_location_getLocation;


import { focusableInput_form as focusableInput } from 'require-global';



import { shared_utils_inputValidator as inputValidator } from 'require-global';



import { default as loadingBars } from 'swug-fdRequire-call:@fd-assets/core-styles/loadingBars';



import { Fandango as Fandango_context_movieDetails } from 'require-core';

const { context: { device: { isMobile } }, movieDetails: { id: movieId, title: movieTitle, sponsoredFanAlert } } = Fandango_context_movieDetails;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_overlay as overlay } from 'base-libraries';



import { Fandango_adobeLaunch as adobeLaunch } from 'require-global';



import { swig as swig } from 'require-core';



import { Fandango_util as util } from 'require-global';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    CONTAINER: '#new-fan-alert',
    ERROR_MSG: '.js-fan-alert-error',
    FORM_BODY: '#fanalert-form-body',
    FORM_SUBMIT: '#fanalert-form-submit',
    FORM: '#fanalert-form',
    FORM_EXPOSED: '#fanalert-form-exposed',
    INFO: '#fanalert-info',
    INFO_BTN: '.js-fanalert-info-btn',
    NOTIFY_BTN: '#fanalert-notify-me',
    SUCCESS_MSG: '#fanalert-success',
}


const Styles = {
    FORM_INPUT: 'new-fanalert__form-input',
    FORM_INPUT_LABEL: 'new-fanalert__form-input-label',
    HIDE: 'hide',
    MODAL_CLOSE_BTN: 'new-fanalert__modal-close-btn',
    MODAL_CONTAINER: 'new-fanalert__modal-container',
}


const ErrorMessages = {
    SERVER_ERROR: 'Sorry something went wrong on our end. Please try again later.'
}
function setSaving(isSaving) {
    const submitBtn = document.querySelector(Selectors.FORM_SUBMIT);
    if (submitBtn) {
        if (isSaving) {
            loadingBars.start(submitBtn);
        }
        else {
            loadingBars.stop(submitBtn);
        }
    }
}
function validateFields(fields) {
    const { ValidationTypes, validate } = inputValidator;
    const { email, fanalertZipCode } = fields;
    const validationRules = [{
            input: email,
            name: 'email',
            isRequired: true,
            type: ValidationTypes.EMAIL
        }, {
            input: fanalertZipCode,
            name: 'zipCode',
            isRequired: true,
            type: ValidationTypes.ZIP,
        }];
    const { hasErrors, errors, email: validatedEmail, zipCode: validatedZipCode } = validate(validationRules);
    return {
        errors,
        hasErrors,
        msg: !hasErrors ? '' : errors.map(({ error }) => error).join('<br>'),
        validatedEmail,
        validatedZipCode,
    };
}
function showError(msg) {
    const el = document.querySelector(Selectors.ERROR_MSG);
    el && (el.innerHTML = msg);
}
function onPostFail(error) {
    setSaving(false);
    debugLog.warn(module.name, JSON.stringify(error || {}));
    showError(ErrorMessages.SERVER_ERROR);
}
function onPostFanMailDone(data) {
    setSaving(false);
    if (!data) {
        return showError(ErrorMessages.SERVER_ERROR);
    }
}
function onPostFanAlertDone() {
    util.track('fan alert sign up');
    adobeLaunch.track(adobeLaunch.EventTypes.FAN_ALERT_SIGNUP);
    $(Selectors.FORM_BODY).html(swig.render('_newFanalertSuccess', { movieTitle, sponsoredFanAlert }));
    $(Selectors.NOTIFY_BTN).addClass(Styles.HIDE);
    $(Selectors.SUCCESS_MSG).removeClass(Styles.HIDE);
}
function postFanMail(email) {
    const body = {
        email,
        subscriptionLocation: 'MOP FanAlert Module',
        unsubscribe: false,
        unsubscribeCode: '',
        subscriptionType: 'FanMail'
    };
    xhr.ajax({
        method: 'POST',
        url: links.napiSubscription(),
        data: body,
    })
        .done(onPostFanMailDone)
        .fail(onPostFail);
}
function formMarkup() {
    const location = getLocation();
    return swig.render('_newFanalertForm', {
        aboutUsURL: links.aboutUs(),
        emailInput: swig.render('_focusableInput', {
            holderStyle: Styles.FORM_INPUT,
            id: 'email',
            isRequired: true,
            label: 'Email Address',
            name: 'email',
        }),
        movieTitle,
        sponsoredFanAlert,
        privacyPolicyLink: links.policies({ page: 'privacy-policy' }),
        termsPoliciesLink: links.policies({ page: 'terms-and-policies' }),
        zipInput: swig.render('_focusableInput', {
            holderStyle: Styles.FORM_INPUT,
            id: 'fanalertZipCode',
            isRequired: true,
            label: 'Postcode',
            name: 'fanalertZipCode',
            value: location?.postalCode ? location.postalCode : '',
        })
    });
}
function showExposedForm(isMobile) {
    const markup = formMarkup();
    if (isMobile) {
        $(Selectors.FORM_EXPOSED).html(markup);
    }
    else {
        $(Selectors.CONTAINER).replaceWith(markup);
    }
    focusableInput.attach(document.querySelector(Selectors.FORM));
    $(Selectors.FORM).on('submit', onFormSubmit);
}
function onFormSubmit(e) {
    e.preventDefault();
    setSaving(true);
    const fields = e.currentTarget.elements;
    const { hasErrors, errors, validatedEmail, validatedZipCode } = validateFields(fields);
    if (hasErrors) {
        setSaving(false);
        return focusableInput.toggleErrors(errors, true);
    }
    const { allEmailsSignUp } = fields;
    const formData = {
        id: movieId,
        email: validatedEmail,
        zip: validatedZipCode,
        source: isMobile ? 'fandango-mobile-web' : 'fandango-web'
    };
    if (allEmailsSignUp.checked) {
        postFanMail(formData.email);
    }
    xhr.ajax({
        method: 'POST',
        url: sponsoredFanAlert ? links.napiSponsoredFanAlert() : links.napiFanAlert(),
        data: formData,
    })
        .done(onPostFanAlertDone)
        .fail(onPostFail);
}
function onNotifyAnchor() {
    $('html, body').animate({
        scrollTop: ($(Selectors.FORM_EXPOSED).offset().top - 92)
    }, 500);
}
function onInfoClick(e) {
    e.preventDefault();
    const markup = swig.render('_newFanalertInfo');
    overlay.open(markup, {
        closeBtnParent: Selectors.INFO,
        closeBtnStyle: Styles.MODAL_CLOSE_BTN,
        overlayStyle: Styles.MODAL_CONTAINER,
    });
}
function init() {
    showExposedForm(isMobile);
    $(Selectors.NOTIFY_BTN).on('click', onNotifyAnchor);
    $(Selectors.INFO_BTN).on('click', onInfoClick);
}
module.exports = {
    init
};
export default module.exports;